var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.layoutType === 'layout_one')?_c('LayoutOne',{attrs:{"binding-type":_vm.bindingType}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }